import {
	Contactway,
	Followupserie,
	FusUpdateModes,
	TagsObj,
} from "../definitions/types"
import {
	Component,
	Input,
	ViewChild,
	booleanAttribute,
	computed,
	signal,
	ChangeDetectionStrategy,
} from "@angular/core"
import {
	AutoCompleteKeyUpObj,
	ConfigDefinitions,
	FollowupserieSave,
} from "@app/definitions/types"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import { TimePickerComponent } from "@app/utils/time-picker/time-picker.component"
import * as moment from "moment"
import { OptionsList } from "../definitions/opts"
import { pluck } from "@app/services/api.service"
import { Modalable } from "@app/Modalable"
import { AutocompleteWithTagsComponent } from "@app/gen-inputs/autocomplete-with-tags/autocomplete-with-tags.component"
import { dateDisplay, flipYesNo } from "@app/helpers"
import { COMMON_IMPORTS } from "../common-imports"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import {
	BtnExtComponent,
	CancelBtnComponent,
	SpinOrContent,
	YesNo,
} from "@app/utils/utils.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { InArrayPipe } from "@app/utils/in-array.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { AddInvoiceComponent } from "@app/add-invoice/add-invoice.component"
import { ChangeLimitDateComponent } from "@app/change-limit-date/change-limit-date.component"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { HomeMeetingComponent } from "@app/home-meeting/home-meeting.component"
import { GenTableAddItemComponent } from "@app/gen-table-add-item/gen-table-add-item.component"
import { InsertPatientFormComponent } from "@app/insert-patient-form/insert-patient-form.component"
import { ConfirmComponent } from "@app/confirm/confirm.component"
import { PatientComponent } from "@app/patient/patient.component"

function defaultFus(value: any) {
	return value || new FollowupserieSave()
}
function defaultEmptyArr(value: any) {
	return value || []
}

@Component({
	selector: "app-add-meeting",
	imports: [
		COMMON_IMPORTS,
		GenButtonGroupComponent,
		LangValPipe,
		SpinOrContent,
		GenAutocompleteComponent,
		GenInputComponent,
		YesNo,
		AutocompleteWithTagsComponent,
		InArrayPipe,
		DatePickerComponent,
		TimePickerComponent,
		CancelBtnComponent,
		ModalWrapComponent,
		BtnExtComponent,
		AddInvoiceComponent,
		ChangeLimitDateComponent,
		DateFormatPipe,
		HomeMeetingComponent,
		GenTableAddItemComponent,
		InsertPatientFormComponent,
		ConfirmComponent,
		PatientComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./add-meeting.component.html",
})
export class AddMeetingComponent extends Modalable {
	modalProps: any = null

	errors: any = {} //will hold errors for the fields in the form
	OptionsList = OptionsList
	@Input() inputDate: Date | null = null
	@Input() inputMinutes: number = 0
	@Input() location_id: number = 0
	@Input() locationIds: number[] = []
	siteDataLoaded: boolean = false
	isTodayOrEarlier: boolean = false
	isTodayOrLater: boolean = false
	isPastEvent: boolean = false //(currently) is before recent past
	isDatePast: boolean = false //(currently) is today or tomorrow
	isPastAddition: boolean = false //for new fus, is (currently) is before recent past
	followup: any = null
	patient: any = null

	@ViewChild("personFuzzyInput") personFuzzyInput!: GenAutocompleteComponent
	@ViewChild("meetingtypeFuzzyInput")
	meetingtypeFuzzyInput!: GenAutocompleteComponent
	@ViewChild("locationFuzzyInput") locationFuzzyInput!: GenAutocompleteComponent
	@ViewChild("tarifFuzzyInput") tarifFuzzyInput!: GenAutocompleteComponent
	@ViewChild("subUsersFuzzyInput") subUsersFuzzyInput!: GenAutocompleteComponent
	@ViewChild("datePicker") datePicker!: DatePickerComponent
	@ViewChild("untilDatePicker") untilDatePicker!: DatePickerComponent
	@ViewChild("timePicker") timePicker!: TimePickerComponent
	@ViewChild("timeToPicker") timeToPicker!: TimePickerComponent
	@ViewChild("subUsersAC") subUsersAC!: AutocompleteWithTagsComponent
	@ViewChild("locationsAC") locationsAC!: AutocompleteWithTagsComponent

	@Input({ transform: defaultFus }) followupserie: FollowupserieSave =
		new FollowupserieSave()
	otObjs: any = {
		personObj: null,
		meetingObj: null,
		locationObj: null,
		tarifObj: null,
	}
	meetingType: any = null
	followupType: any = null
	btns: any = { duplicate: false, delete: false }
	@Input({ transform: booleanAttribute }) isUpdateMode: boolean = false
	@Input({ transform: booleanAttribute }) isDuplicate: boolean = false

	@Input({ transform: booleanAttribute }) isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	isFormSubmittableWithOrig: boolean = false
	payors: any[] = []
	followuptypes: any[] = [] //1,4,5,6
	repeatOptions = signal<string[]>([])
	repeatOptionsNV = computed(() =>
		this.repeatOptions().map((it) => ({ name: it, value: it }))
	)
	originalDateUnix: string = ""
	originalDate: string = ""
	originalTime: string = ""
	isInVac: boolean = false

	sub_users: any[] = []
	sub_user_objs: any[] = []
	ownerHasUsers: boolean = false
	@Input() userId: number = 0
	locationApprovedIds: number[] = []
	locationWarning: string = ""
	isPreUpdateFirstValidation: boolean = false
	only_therapist_id: number = 0
	locations_only: boolean = false
	show_is_assoc: boolean = false
	search_by_tags_add_meeting: boolean = false
	isDeletedDisabled: boolean = false
	followupserieOrig: any = null
	change_series_opts: any[] = []
	userExcludeIds: string[] = []

	isSaving: "save" | "delete" | false = false
	loadingSubUsers: boolean = false
	isFetchingPatient: boolean = false

	@Input() meeting_request: any = null
	mrMessage: string = ""

	@Input({ transform: defaultEmptyArr }) dayEventsAll: any[] = []
	switchLocationRows: any[] = []
	switchLocationOpen: boolean = false
	switchLocationSpinner: boolean = false
	@Input() creatingObj: any = null
	fetchingFollowup: boolean = false
	changedSeriesRepeatOnUpdate: boolean = false
	locationTagsObj = new TagsObj()
	userTagsObj = new TagsObj()
	isVacPastEdit: boolean = false

	deactivateSpin: boolean = false
	filterSubUsersOpen: boolean = false
	filterLocationsOpen: boolean = false

	async ngOnInit() {
		//when called to open
		this.change_series_opts = [...OptionsList.change_series_opts].map((it) => ({
			...it,
		}))
		this.ownerHasUsers = this.permsService?.owner_has_users
		this.reCalcLocationApprovedIds()
		this.userExcludeIds = this.store
			.getSiteDataTable("sub_users")
			.filter((it) => it.active == "no")
			.map((it) => it.id)
		this.loadData()
	}
	ngAfterViewInit() {
		if (!this.isUpdateMode && this.userId) {
			const user = this.store.searchSiteDataItem(this.userId, ["sub_users"])
			this.updateSubUsers([
				...this.sub_users,
				{ ...user, typeClassName: "sub_users" },
			])
			// this.addSubUser({ ...user, typeClassName: "sub_users" });
		}
	}

	getInitLocations() {
		let arr = this.store
			.getSiteDataTable("locations")
			.filter((it) => it.active === "yes")
		if (this.locationIds?.length) {
			arr = arr.filter((it) => this.locationIds.includes(it.id))
		}
		return arr
	}

	async loadData() {
		this.siteDataLoaded = true

		const doChooseTarif =
			!this.isUpdateMode &&
			this.permsService.owner_has_users &&
			!this.permsService?.perms?.administrative &&
			!this.permsService?.perms?.assign_sub_users

		if (doChooseTarif) {
			const userId = this.store.cc().user_id
			const tarifId = this.store.searchSiteDataItem(userId, [
				"sub_users",
			])?.tarif_id
			if (tarifId) {
				const tarif = this.store.searchSiteDataItem(tarifId, ["tarifs"])
				if (tarif) {
					this.chooseTarif(tarif)
				}
			}
		}

		const cc = this.store.cc()
		this.only_therapist_id = cc?.only_therapist_id
		this.locations_only = cc?.locations_only
		this.show_is_assoc = cc?.show_is_assoc == "yes"
		this.search_by_tags_add_meeting = cc?.search_by_tags_add_meeting == "yes"

		this.errors = {}
		if (this.isUpdateMode) {
			this.isPreUpdateFirstValidation = true
			this.followupserie.is_new_patient_or_contact = "no"
			this.followupserie.followupserie_date = (this.followupserie as any).date
			this.followupserie.followupserie_date_to = (
				this.followupserie as any
			).date_to
			this.followupserie.followupserie_time = this.followupserie.time
			this.followupserie.followupserie_time_to = this.followupserie.time_to
			this.followupserie.followupserie_du_remarks = ""
			this.followupserie.is_create_overlap_exceptions = "no"
			this.btns = { duplicate: this.isDuplicate, delete: true }
			this.isDeletedDisabled = !!this.store.hasInvoiceIdPerson(
				this.followupserie
			)

			this.sub_user_objs = this.store.getAssocSubUsersForFus(this.followupserie)

			this.followupserieOrig = { ...this.followupserie }

			this.isTodayOrLater = (moment as any)().isSameOrBefore(
				(this.followupserie as any).date,
				"date"
			)
		} else {
			const tomorrow = moment.utc().add(1, "day").startOf("day")
			if (moment.utc(this.inputDate || new Date()).isBefore(tomorrow)) {
				this.isTodayOrEarlier = true
			}
			//find default meetintype and assign it
			let meetingtype = this.store
				.getSiteDataTable("meetingtypes")
				.find((it) => it.is_default == "yes")
			if (meetingtype) {
				this.followupserie.meetingtype_id = meetingtype.id
			}
		}

		if (this.creatingObj) {
			this.inputMinutes = this.creatingObj.length
			this.followupserie.meetingtype_id = this.creatingObj.meetingtype_id
			this.followupserie.series_repeat = this.creatingObj.series_repeat
			if (this.creatingObj?.assoc_sub_user_id) {
				this.userId = this.creatingObj.assoc_sub_user_id
			}
			if (this.creatingObj?.location_id) {
				this.location_id = this.creatingObj.location_id
			}
		}
		//is date more than 48 hours back?
		this.isPastEvent = !this.store.isDateRecentPast(
			(this.followupserie as any).date
		)
		this.isDatePast = !this.store.isDatePast((this.followupserie as any).date)
		if (
			this.isUpdateMode &&
			(this.isPastEvent || this.isDatePast) &&
			this.followupserie.followuptype_id === 5 &&
			this.store.isTomorrowOrLater(this.followupserie.followupserie_date_to)
		) {
			this.isVacPastEdit = true
		}

		this.isPastAddition =
			!this.isUpdateMode &&
			!!this.inputDate &&
			!this.store.isDateRecentPast(this.inputDate)

		if (this.isPastEvent) {
			this.change_series_opts = this.change_series_opts.filter(
				(it) => it.value == "only_one"
			)
		}

		//
		this.originalDateUnix = (this.followupserie as any)?.start_unix
		this.originalDate = (this.followupserie as any)?.date_render
		this.originalTime = this.followupserie.followupserie_time

		this.payors = [...this.store.getSiteDataTable("payors")]
		this.followuptypes = this.store.getSiteDataTable("followuptypes")
		if (this.isTodayOrEarlier) {
			this.followuptypes = this.followuptypes.filter((it) => it.id != 5)
		}
		this.followuptypes.forEach(
			(item) => (item.name = this.lang.getVal(item.name))
		)

		this.updFollowuptype(true)

		this.meetingType = this.store
			.getSiteDataTable("meetingtypes")
			.find((it) => it.id == this.followupserie.meetingtype_id)
		if (this.meetingType) {
			if (this.isUpdateMode) {
				this.otObjs.meetingObj = this.meetingType
				this.followupserie.meetingtype_id = this.meetingType.id
			} else {
				this.chooseMeetingtype(this.meetingType, true)
			}
		}

		const location = this.store
			.getSiteDataTable("locations")
			.find((it) => it.id == this.followupserie.location_id)
		if (location) {
			this.otObjs.locationObj = location
		}
		const tarif = this.store
			.getSiteDataTable("tarifs")
			.find((it) => it.id == this.followupserie.tarif_id)
		if (tarif) {
			this.otObjs.tarifObj = tarif
		}

		let personFields = {
			contact_id: "contacts",
			patient_id: "patients",
			user_id: "sub_users",
		}
		Object.keys(personFields).forEach((fieldName) => {
			let collection = personFields[fieldName]
			if (this.followupserie[fieldName]) {
				let persObj = this.store
					.getSiteDataTable(collection)
					.find((it) => it.id == this.followupserie[fieldName])
				if (persObj) {
					this.otObjs.personObj = persObj
					persObj.typeClassName = collection
					// this.choosePatientOrContact(persObj, true);
				}
			}
			this.followupserie = { ...this.followupserie }
		})

		// this.followupserie={...this.followupserie};
		if (this.inputMinutes) {
			this.followupserie.length = this.inputMinutes
			this.followupserie.followupserie_time_to = moment
				.utc(
					(this.followupserie.start_unix + this.followupserie.length * 60) *
						1000
				)
				.format("HH:mm")

			//if vacation - change time_to
		}
		if (this.inputDate) {
			const date = moment.utc(this.inputDate)
			const endDate = moment.utc(date).add(this.followupserie.length, "m")
			this.followupserie.followupserie_date = date.format(
				ConfigDefinitions.momentDateFormat
			)
			this.followupserie.followupserie_date_to = endDate.format(
				ConfigDefinitions.momentDateFormat
			)
			this.followupserie.followupserie_time = date.format("HH:mm")
			this.followupserie.followupserie_time_to = endDate.format("HH:mm")
		}

		await this.updateIsFusInVac()

		if (this.isUpdateMode) {
			//&& !this.store.isFusAReminder(this.followupserie )

			if (
				(!this.isInVac || this.followupserie.meeting_on_holiday == "yes") &&
				this.getPatientOrUserId()
			) {
				const fusIds = this.store.getAssocFusIdsForUser()

				if (
					!this.permsService?.owner_has_users ||
					(this.permsService?.perms?.clinical &&
						fusIds.includes(String(this.followupserie.id)))
				) {
					const person_id = this.getPatientOrUserId()
					const fieldname = this.followupserie.patient_id
						? "patient_id"
						: "user_id"

					this.followup = await this.store.getFollowupForSeries(
						person_id,
						this.followupserie.id,
						this.followupserie.followupserie_date,
						fieldname
					)
					if (
						!this.isDeletedDisabled &&
						this.store.hasInvoiceIdPerson(this.followup)
					) {
						this.isDeletedDisabled = true
					}
				}
			}
		} else {
			this.suggestTarif()
		}

		if (this.location_id) {
			const location = this.store.searchSiteDataItem(this.location_id, [
				"locations",
			])
			this.chooseLocation(location)
		}

		if (this.only_therapist_id) {
			if (!this.locations_only) {
				this.followupserie.location_id =
					this.store.getSiteDataTable("locations")[0]?.id
			}
			this.followupserie.tarif_id = this.store.getSiteDataTable("tarifs")[0]?.id
			this.followupserie.assoc_sub_user_ids = [String(this.only_therapist_id)]
		}

		if (this.isUpdateMode) {
			this.followupserie.change_series = ""
			this.followupserie.followupserie_series_id = this.followupserie.id
			this.followupserie.current_original_date = this.originalDateUnix

			if (this.followupserie.series_repeat != "one_time") {
				this.followupserie.followupserie_du_message = `${this.lang.getVal("update")} ${moment.utc().format(ConfigDefinitions.momentDateDisplay + " HH:mm")}` //default message to be saved as this change;
				this.followupserie.followupserie_until_date =
					this.followupserie.followupserie_date
				this.followupserie.followupserie_du_remarks = ""
			}

			this.validateEntireForm()
		}
		this.suggestLocation()

		await this.store.timeout(900)
		this.manageMeetingRequest()
		this.tryGetPatient()
	}
	async tryGetPatient() {
		if (
			this.followupserie.patient_id &&
			!this.patient &&
			!this.isFetchingPatient
		) {
			this.isFetchingPatient = true
			this.patient = await this.store.getPatient(this.followupserie.patient_id)
			if (!this.followupserie.patient_id) {
				this.patient = null
			}
			this.isFetchingPatient = false
		}
	}

	async manageMeetingRequest() {
		if (!this.meeting_request) {
			return
		}
		this.meeting_request = this.store.removeDecItem(this.meeting_request)
		this.followupserie.meeting_request_id = this.meeting_request.id
		this.followupserie.notes = this.meeting_request.remarks || ""

		if (this.meeting_request.meetingtype_id) {
			const meetingtype = this.store.searchSiteDataItem(
				this.meeting_request.meetingtype_id,
				["meetingtypes"]
			)
			if (meetingtype) {
				await this.store.timeout(100)
				this.chooseMeetingtype(meetingtype)
			}
		}

		const { foundPatient, isNewPerson, mrMessage } =
			await this.store.getMeetingRequestData(this.meeting_request)

		this.mrMessage = this.lang.getVal(mrMessage)
		if (foundPatient) {
			const obj = { ...foundPatient, typeClassName: "patients" }
			this.choosePatientOrContact(obj)
		}
		if (isNewPerson) {
			this.updFollowupserie("is_new_patient_or_contact", "yes")
			this.onNewPerson()
			this.followupserie.name = this.meeting_request.name
			this.followupserie.new_phone_input = this.meeting_request.phone
			this.followupserie.new_phone_input2 = this.meeting_request.email
			this.validateEntireForm()
		}
	}

	isFollowupserieLikeOrig() {
		if (!this.followupserieOrig) {
			return false
		}

		const fields =
			"meetingtype_id,location_id,followupserie_date,followupserie_time,followupserie_date_to,followupserie_time_to,length,price,charged,takes_place,series_repeat,tarif_id,followupserie_du_remarks".split(
				","
			)
		for (let field of fields) {
			if (["followupserie_time", "followupserie_time_to"].includes(field)) {
				const origVal = this.followupserieOrig[field].substring(0, 5)
				const curVal = this.followupserie[field].substring(0, 5)
				if (origVal != curVal) {
					return false
				}
			} else if (this.followupserie[field] != this.followupserieOrig[field]) {
				return false
			}
		}
		return true
	}

	async updateIsFusInVac() {
		const ownerHasUsers = this.permsService?.owner_has_users

		const fusArr: any = await this.store.getAllFus()
		this.isInVac = false
		// this.followupserie.meeting_on_holiday = "no";

		const vacations = fusArr.followupseries.filter(
			(fus) => fus.followuptype_id == 5
		)
		const fusStart = moment.utc(
			`${this.followupserie.followupserie_date} ${this.followupserie.followupserie_time}`
		)
		const fusEnd = moment
			.utc(fusStart)
			.add(this.followupserie.length, "minutes")

		const fusAssocUsers: any[] = this.store.getFusSpreadAssocIds(
			this.followupserie
		)

		for (let vac of vacations) {
			if (ownerHasUsers) {
				//if assoc check is needed

				//only be able to dismiss this vac if no vacation_all_users
				if (vac?.vacation_all_users != "yes") {
					const vacAssocUserId = vac.assoc_sub_user_ids?.length
						? vac.assoc_sub_user_ids[0]
						: 0
					if (
						!fusAssocUsers?.length ||
						!fusAssocUsers.includes(String(vacAssocUserId))
					) {
						//if this vac assoc user ISN'T part of the fus assoc users - continue to next vac
						continue
					}
				}
			}
			const vacStart = moment.utc(`${vac.date} ${vac.time}`)
			const vacEnd = moment.utc(`${vac.date_to} ${vac.time_to}`)

			//trap the fusStart
			if (fusStart.isBetween(vacStart, vacEnd, null, "[)")) {
				this.isInVac = true
				break
			}

			//trap the fusEnd
			if (fusEnd.isBetween(vacStart, vacEnd, null, "(]")) {
				this.isInVac = true
				break
			}

			//trap the fusStart
			if (vacStart.isBetween(fusStart, fusEnd, null, "(]")) {
				this.isInVac = true
				break
			}

			//trap the fusEnd
			if (vacEnd.isBetween(fusStart, fusEnd, null, "[)")) {
				this.isInVac = true
				break
			}
		}
		if (this.isInVac) {
			this.followupserie.series_repeat = "one_time"
			// this.followupserie.meeting_on_holiday = "yes";

			if (this.isUpdateMode) {
				this.validateEntireForm()
			}
		}
		this.updRepeatOptions()
	}

	async openFollowupEditModal() {
		this.fetchingFollowup = true
		if (this.followup.patient_id) {
			const patient = await this.store.getPatient(this.followup.patient_id)
			this.modalProps = { name: "patient-followup", patient }
			return
		}
		const user = this.store.searchSiteDataItem(this.followup.user_id, [
			"sub_users",
		])
		this.modalProps = { name: "home-meeting", followup: this.followup, user }
	}
	getPatientOrUserId() {
		return this.followupserie.patient_id || this.followupserie.user_id
	}

	async tryGetLastPrice() {
		if (
			this.getPatientOrUserId() &&
			this.followupserie.followuptype_id == 1 &&
			this.followupserie.meetingtype_id
		) {
			this.loadingSubUsers = true
			const person_id = this.getPatientOrUserId()
			const fieldname = this.followupserie.patient_id ? "patient_id" : "user_id"

			const res: any = await this.apiService.post("get_last_followup_price", {
				person_id,
				fieldname,
				...pluck(this.followupserie, "meetingtype_id"),
			})
			this.loadingSubUsers = false
			if (res.price >= 0) {
				this.followupserie.price = res.price
				this.validateEntireForm()
			}

			// if (!this.isUpdateMode && this.permsService.perms?.assign_sub_users && res?.assoc_user_ids.length) {

			if (
				!this.isUpdateMode &&
				this.permsService.perms?.administrative &&
				this.permsService.owner_has_users &&
				res?.assoc_user_ids.length &&
				!this.only_therapist_id
			) {
				res.assoc_user_ids.forEach((sub_user_id) => {
					const find = this.store.searchSiteDataItem(sub_user_id, ["sub_users"])
					if (find) {
						this.updateSubUsers([
							...this.sub_users,
							{ ...find, typeClassName: "sub_users" },
						])
						// this.addSubUser({ ...find, typeClassName: "sub_users" });
					}
				})
			}
		}
	}

	updFollowupserie(fieldName: string, value: any) {
		this.followupserie[fieldName] = value

		if (fieldName == "meeting_with") {
			let doReset = value == "meeting"
			this.setMeetingInfo(doReset)
			if (value == "meeting") {
				this.followupserie.patient_id = 0
				this.followupserie.contact_id = 0
				this.followupserie.user_id = 0
				this.followupserie.is_new_patient_or_contact = "no"
				this.followupserie.meeting_title =
					this.personFuzzyInput?.searchStr || ""
			}
		}
		if (fieldName == "series_repeat") {
			this.suggestLocation()
		}
		if (this.isUpdateMode && fieldName == "series_repeat") {
			this.changedSeriesRepeatOnUpdate = true
			this.followupserie.change_series = "now_on"
		}
		this.validateEntireForm()
	}

	setMeetingInfo(doReset: boolean) {
		if (this.store.isFusAReminder(this.followupserie)) {
			return
		}

		if (doReset) {
			this.followupserie.price = 0
			this.emptyAssoc()
		} else {
			if (this.followupserie.followuptype_id == 1) {
				this.chooseMeetingtype(this.meetingType)
			}
		}
	}
	chVacationIsAll() {
		if (this.followupserie.vacation_all_users == "yes") {
			this.emptyAssoc()
		}
		this.validateEntireForm()
	}

	async updFollowupserieAlt(fieldName: string) {
		if (!this.isUpdateMode && fieldName == "followupserie_date") {
			let isRecentPast = this.store.isDateRecentPast(
				this.followupserie.followupserie_date
			)
			this.isPastAddition = !isRecentPast
			if (this.isPastAddition) {
				this.followupserie.series_repeat = "one_time"
			}
			this.updRepeatOptions()
		}
		//suggestLocation
		const suggestLocationFields = ["followupserie_date", "followupserie_time"]
		if (suggestLocationFields.includes(fieldName)) {
			this.suggestLocation()
		}

		this.updateIsFusInVac()
		this.validateEntireForm()
		if (fieldName == "followupserie_date_to") {
			await this.store.timeout(50)
			this.timeToPicker?.inpEl?.nativeElement.focus()
		}
	}

	updNewPersonType(value: string, isGroup: boolean = false) {
		this.followupserie.is_group = isGroup ? "yes" : "no"
		this.followupserie.meeting_with = value
		this.setMeetingInfo(this.followupserie.meeting_with == "contact")
		this.validateEntireForm()
	}

	onNewPerson() {
		this.followupserie.patient_id = 0
		this.followupserie.contact_id = 0
		this.followupserie.user_id = 0

		if (this.followupserie.is_new_patient_or_contact == "yes") {
			this.followupserie.name = this.personFuzzyInput?.searchStr || ""
		}
		if (this.personFuzzyInput) {
			this.personFuzzyInput.searchStr = ""
		}
		if (
			this.followupserie.meeting_with != "patient" &&
			this.followupserie.meeting_with != "contact"
		) {
			this.followupserie.meeting_with = "patient"
		}
		// if(this.followupserie.is_new_patient_or_contact == 'no'){

		// }
	}

	validateField(fieldName: string) {}

	async suggestLocation() {
		this.prepFusForServer()

		if (!this.ownerHasUsers) {
			return
		}
		if (this.followupserie.followuptype_id != 1) {
			return
		}

		this.reCalcLocationApprovedIds()

		if (this.isUpdateMode) {
			return
		}

		//fus start,fus end
		const fusEndMom = moment.utc(
			this.followupserie.followupserie_date_to +
				" " +
				this.followupserie.followupserie_time_to
		)
		const fusStartMom = moment.utc(
			this.followupserie.followupserie_date +
				" " +
				this.followupserie.followupserie_time
		)
		//get ta with the first assoc user of this fus AND this day
		const day = fusStartMom.day()

		//if at least one assoc -
		const assocUsers = this.store.getFusSpreadAssocIds(this.followupserie)
		const assocUserId = assocUsers[0]
		if (!assocUserId) {
			return
		}
		const tas = this.store
			.getSiteDataTable("time_allocations")
			.filter((ta) => ta.user_id == assocUserId && ta.day == day)
		if (!tas.length) {
			return
		}

		//if fus in TOTALLY contained in ta - choose this ta and suggest location_id
		for (let ta of tas) {
			const taStartMom = moment.utc(
				fusStartMom.format(ConfigDefinitions.momentDateFormat) + " " + ta.time
			)
			const taEndMom = moment.utc(
				fusStartMom.format(ConfigDefinitions.momentDateFormat) +
					" " +
					ta.time_to
			)
			if (
				fusStartMom.isBetween(taStartMom, taEndMom, null, "[]") &&
				fusEndMom.isBetween(taStartMom, taEndMom, null, "[]")
			) {
				//is this location already occupied?
				const testFus = this.preOverlapChange({ ...this.followupserie })
				testFus.location_id = ta.location_id
				const overlapFus = await this.overlapService.find_overlap(testFus)
				if (overlapFus) {
					return
				}

				const obj = this.store.searchSiteDataItem(ta.location_id, ["locations"])
				if (obj) {
					this.followupserie.location_id = obj.id
					if (this.locationFuzzyInput) {
						this.locationFuzzyInput.searchStr = obj.name
					}
					this.chooseLocation(obj)
				}
				return
			}
		}
	}
	async suggestTarif() {
		//if add mode get the tarif from the userws default tarif_id
		if (!this.ownerHasUsers) {
			return
		}
		if (this.followupserie.followuptype_id != 1) {
			return
		}

		const firstAssocUserId = this.followupserie.assoc_sub_user_ids.filter(
			(id) => !id.startsWith("g")
		)[0]
		if (firstAssocUserId) {
			const user = this.store.searchSiteDataItem(Number(firstAssocUserId), [
				"sub_users",
			])
			if (!this.isUpdateMode && user?.tarif_id) {
				const tarif = this.store.searchSiteDataItem(user.tarif_id, ["tarifs"])
				if (tarif) {
					this.chooseTarif(tarif)
				}
			}
		}
	}

	preOverlapChange(fus: FollowupserieSave) {
		if (this.isUpdateMode) {
			switch (fus.change_series) {
				case "only_one":
					fus.series_repeat = "one_time"
					break
				case "until_date":
					fus.series_limit_date = fus.followupserie_until_date
					break
			}
		}
		return fus
	}

	async validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		let fieldsValidationObjects: any = {
			meeting_title: { not_empty: true },
			followupserie_date: { not_empty: true }, //, recent_past_and_later: true
			followupserie_time: { not_empty: true },
			followupserie_date_to: { not_empty: true },
			followupserie_time_to: { not_empty: true },
			length: { not_empty: true, is_positive: true, is_integer: true },
			name: { not_empty: true },
			patient_id: { is_legit_fuzzy_value_patient_contact: true },
			user_id: { is_legit_fuzzy_value_patient_contact: true },
			contact_id: { is_legit_fuzzy_value_patient_contact: true },
			meetingtype_id: { is_legit_fuzzy_value: true },
			location_id: { is_legit_fuzzy_value: true },
			tarif_id: { is_legit_fuzzy_value: true },
			price: { is_decimal_or_zero: true },
			assoc_sub_user_ids: { not_empty: true },
			change_series: { not_empty: true },
			followupserie_du_remarks: { not_empty: true, has_closing_tags: true },
			followupserie_until_date: {
				not_empty: true,
				date_and_later: (this.followupserie as any).date,
			},
		}
		let fieldsToValidate: string[] = []

		// if (this.isPastAddition) {
		// 	fieldsValidationObjects.followupserie_date = { not_empty: true };
		// }

		this.errors = {}

		if (this.isUpdateMode && this.followupserie.series_repeat != "one_time") {
			fieldsToValidate.push("change_series")
		}
		if (this.isUpdateMode && this.followupserie.change_series == "until_date") {
			fieldsToValidate.push("followupserie_until_date")
		}

		const followupserie_du_remarks_validation: any = { has_closing_tags: true }
		if (
			this.isPastEvent &&
			this.followupserie.meeting_with !== "meeting" &&
			!this.followupserie.contact_id
		) {
			followupserie_du_remarks_validation.not_empty = true
			// fieldsToValidate.push("followupserie_du_remarks");
		}
		this.validator.validateField(
			this.followupserie,
			this.errors,
			"followupserie_du_remarks",
			followupserie_du_remarks_validation
		)

		if (
			this.followupserie.followuptype_id == 1 &&
			["patient", "user"].includes(this.followupserie.meeting_with)
		) {
			fieldsToValidate.push("meetingtype_id")
		}
		if (
			this.permsService.owner_has_users &&
			this.followupserie.followuptype_id == 1
		) {
			fieldsToValidate.push("location_id")
			if (["patient", "user"].includes(this.followupserie.meeting_with)) {
				fieldsToValidate.push("tarif_id")
			}
		}
		fieldsToValidate.push("followupserie_date")
		fieldsToValidate.push("followupserie_time")
		if (this.followupserie.followuptype_id != 5) {
			fieldsToValidate.push("length")
		}
		if (this.followupserie.followuptype_id == 5) {
			//vacation
			if (!this.isVacPastEdit) {
				fieldsValidationObjects.followupserie_date.tomorrow_and_later = true
			}
			fieldsValidationObjects.followupserie_date_to.tomorrow_and_later = true

			fieldsToValidate.push("followupserie_date_to")
			fieldsToValidate.push("followupserie_time_to")
		} else {
			switch (this.followupserie.meeting_with) {
				case "meeting":
					fieldsToValidate.push("meeting_title")
					break
				case "patient":
				case "contact":
				case "user":
					switch (this.followupserie.is_new_patient_or_contact) {
						case "yes":
							fieldsToValidate.push("name")
							// if(!this.followupserie.new_phone_input){
							// 	this.errors.new_phone_input="bad!";
							// }
							break
						case "no":
							let field = this.followupserie.meeting_with + "_id"
							fieldsToValidate.push(field)
							break
					}
					break
			}
		}
		// if (!this.isUpdateMode && this.permsService.perms?.assign_sub_users) {
		if (
			!this.isUpdateMode &&
			this.permsService.perms?.administrative &&
			this.permsService.owner_has_users &&
			this.followupserie.is_assoc == "yes"
		) {
			if (
				this.followupserie.followuptype_id != 5 ||
				this.followupserie.vacation_all_users == "no"
			) {
				fieldsToValidate.push("assoc_sub_user_ids")
			}
		}
		//is series_repeat legit?
		// if(!this.repeatOptions.includes(this.followupserie.series_repeat)){
		// 	this.errors.series_repeat="bad";
		// }

		if (
			this.followupserie.followuptype_id == 1 &&
			this.followupserie.meeting_with != "meeting" &&
			this.followupserie.contact_id == 0
		) {
			fieldsToValidate.push("price")
		}
		if (this.followupserie.followuptype_id != 5) {
			// if(!this.followupserie.price){
			// 	this.errors.price="bad!";
			// }
			// if(!this.followupserie.series_limit_date){
			// 	this.errors.series_limit_date="bad!";
			// }
			if (this.store.isFusAReminder(this.followupserie)) {
				// if(!this.followupserie.repeat_days){
				// 	this.errors.repeat_days="bad!";
				// }
			}
		}
		///////
		fieldsToValidate.forEach((field) => {
			this.validator.validateField(
				this.followupserie,
				this.errors,
				field,
				fieldsValidationObjects[field]
			)
		})

		const startMom = moment.utc(
			this.followupserie.followupserie_date +
				" " +
				this.followupserie.followupserie_time
		)
		//check for vacation start and end times range
		if (this.followupserie.followuptype_id == 5) {
			const endMom = moment.utc(
				this.followupserie.followupserie_date_to +
					" " +
					this.followupserie.followupserie_time_to
			)
			if (!endMom.isAfter(startMom)) {
				this.errors["followupserie_time_to"] = this.lang.getVal(
					"wrong_vacation_time"
				)
			}
		} else {
			const endMom = moment
				.utc(startMom)
				.add(this.followupserie.length, "minutes")
			const isSameDate =
				endMom.format(ConfigDefinitions.momentDateFormat) ===
				startMom.format(ConfigDefinitions.momentDateFormat)
			if (!isSameDate) {
				this.errors["followupserie_time"] =
					this.lang.getVal("moves_to_next_day")
			}
		}

		const testFus = this.preOverlapChange({ ...this.followupserie })
		const overlapFus = await this.overlapService.find_overlap(testFus)
		//this.errors.followupserie_date = this.lang.getVal("time_is_taken") +" "+ this.lang.getVal('betaarich')+ " "+ "[date] "+ this.lang.getVal('beshaa')+ " "+ " [time] "+ this.lang.getVal(overlapFus.series_repeat) +" "
		if (overlapFus && !this.ownerHasUsers) {
			const dateString =
				overlapFus.series_repeat == "one_time"
					? this.lang.getVal("betaarich")
					: this.lang.getVal("from_date")
			const errorString =
				this.lang.getVal("time_is_taken") +
				" " +
				dateString +
				" " +
				"[date] " +
				this.lang.getVal("beshaa") +
				" " +
				" [time] " +
				this.lang.getVal(overlapFus.series_repeat)
			this.errors.followupserie_date = errorString
				.replace("[date]", dateDisplay(overlapFus.date))
				.replace(
					"[time]",
					moment.utc(`${overlapFus.date} ${overlapFus.time}`).format("HH:mm")
				)
				.replace("[series_repeat]", this.lang.getVal(overlapFus.series_repeat))

			if (overlapFus?.isMRConflict) {
				const timeMr = overlapFus.time.slice(-8, 5)
				const dateMr = (moment as any)(overlapFus.date).format("DD-MM-YY")
				this.errors.followupserie_date =
					this.lang.getVal("time_is_requested") +
					"- " +
					this.lang.getVal("betaarich") +
					" " +
					dateMr +
					" " +
					this.lang.getVal("beshaa") +
					" " +
					timeMr
			}
			//TODO
			/* const overlapfusStartMom = moment.utc(overlapFus.date + " " + overlapFus.time);
			 const day = overlapfusStartMom.weekday();  TODO weekday letter
			 let conflict_reason_name = "";
			 if(overlapFus.patient_id){
				 conflict_reason_name = this.store.searchSiteDataItem(overlapFus.patient_id, ["patients"])?.name;
			 }else if(overlapFus.contact_id){
				 conflict_reason_name = this.store.searchSiteDataItem(overlapFus.contact_id, ["contacts"])?.name;
			 }else{
				 conflict_reason_name = overlapFus.meeting_title;
			 }
			 const series_repeat = this.lang.getVal( overlapFus.series_repeat);
			 if (overlapFus && !this.ownerHasUsers) {
				 const overlapTxt = this.lang.getVal("on") + " "+ day +  " " + this.lang.getVal("time") + " " + moment.utc(`${overlapFus.date} ${overlapFus.time}`).format("HH:mm") + " " +
					 this.lang.getVal('a_meeting')  +' ' +series_repeat +' ' +  this.lang.getVal('with') + ' ' + conflict_reason_name  +
					 this.lang.getVal('start_on') + " " + dateDisplay(overlapFus.date);

				 this.errors.followupserie_date = overlapTxt;
			 }*/
		}

		//const langDate= dateDisplay(overlapFus.date);
		//	const langTime= moment.utc(`${overlapFus.date} ${overlapFus.time}`).format("HH:mm");

		const langString = this.lang.getVal("conflict_reason")
		if (overlapFus?.conflictReasons?.length) {
			for (let conflictReason of overlapFus.conflictReasons) {
				let conflict_reason_name = ""
				let fieldName = conflictReason + "_id"
				let in_to = "to1" // for the ל in Hebrew
				let a_meeting_or_series = "a_series"
				if (overlapFus.series_repeat == "one_time") {
					a_meeting_or_series = "a_one_time"
				}

				const overlapAssocUserIds = this.store.getFusSpreadAssocIds(overlapFus)
				const assocName =
					this.store.searchSiteDataItem(overlapAssocUserIds[0], ["sub_users"])
						?.name || ""

				// for the ל in Hebrew
				switch (conflictReason) {
					case "patient":
						conflict_reason_name = this.store.searchSiteDataItem(
							overlapFus.patient_id,
							["patients"]
						)?.name
						break
					case "user":
						conflict_reason_name = this.store.searchSiteDataItem(
							overlapFus.user_id,
							["sub_users"]
						)?.name
						break
					case "contact":
						conflict_reason_name = this.store.searchSiteDataItem(
							overlapFus.contact_id,
							["contacts"]
						)?.name
						break
					case "location":
						in_to = "in"
						conflict_reason_name = this.store.searchSiteDataItem(
							overlapFus.location_id,
							["locations"]
						)?.name
						break
					case "assoc":
						fieldName = "assoc_sub_user_ids"
						const assoc_sub_user_ids: any[] = this.store.getFusSpreadAssocIds(
							this.followupserie
						)
						const overlapAssocUserIds =
							this.store.getFusSpreadAssocIds(overlapFus)
						const userId =
							overlapAssocUserIds.find((userId) =>
								assoc_sub_user_ids.includes(String(userId))
							) || 0
						conflict_reason_name = this.store.searchSiteDataItem(userId, [
							"sub_users",
						])?.name
						break
					// 	const subUSer = this.store.searchSiteDataItem(overlapFus.patient_id, ["sub_users"]);
					// 	this.errors["assoc_sub_user_ids"] = langString
					// 		.replace("[conflict_reason]", this.lang.getVal("patient_reason"))
					// 		.replace("[conflict_reason_name]", patient?.name || "")
					// 		.replace("[date]", overlapFus.date)
					// 		.replace("[time]", overlapFus.time)
					// 		.replace("[series_repeat]", this.lang.getVal(overlapFus.series_repeat));
					// 	break;
				}
				this.errors[fieldName] =
					langString
						.replace(
							"[conflict_reason]",
							this.lang.getVal(conflictReason + "_reason")
						)
						.replace("[in_to]", this.lang.getVal(in_to))
						.replace(
							"[a_meeting_or_series]",
							this.lang.getVal(a_meeting_or_series)
						)
						.replace("[conflict_reason_name]", conflict_reason_name || "")
						.replace("[assocName]", assocName || "")
						.replace("[date]", dateDisplay(overlapFus.date))
						.replace(
							"[time]",
							moment
								.utc(`${overlapFus.date} ${overlapFus.time}`)
								.format("HH:mm")
						)
						.replace(
							"[series_repeat]",
							this.lang.getVal(overlapFus.series_repeat)
						) +
					(overlapFus?.conflictDate
						? `${this.lang.getVal("next_meeting_at")}:${dateDisplay(overlapFus.conflictDate)}`
						: "")
			}
		}

		//max 1 group per assoc
		if (
			this.followupserie.assoc_sub_user_ids.filter((it) => it.startsWith("g"))
				.length > 1
		) {
			this.errors.assoc_sub_user_ids = this.lang.getVal("max_1_group_assoc")
		}
		if (this.isUpdateMode && this.errors.change_series) {
			this.errors.change_series = this.lang.getVal("select_change_serie")
		}
		//patient fus can't have user_groups
		if (
			["patient", "user"].includes(this.followupserie.meeting_with) &&
			this.followupserie.assoc_sub_user_ids.find((it) => it.startsWith("g"))
		) {
			this.errors.assoc_sub_user_ids = this.lang.getVal("no_group_assoc")
		}
		if (
			this.followupserie.followuptype_id == 5 &&
			this.followupserie.assoc_sub_user_ids.find((it) => it.startsWith("g"))
		) {
			this.errors.assoc_sub_user_ids = this.lang.getVal(
				"group_vacation_forbidden"
			)
		}

		//checkAllocationIssues
		this.locationWarning = ""
		if (this.permsService?.owner_has_users) {
			if (this.isPreUpdateFirstValidation) {
				this.isPreUpdateFirstValidation = false
			} else {
				if (
					this.followupserie.location_id &&
					this.followupserie.is_assoc == "yes"
				) {
					//
					let assocUserId = this.store.cc().user_id
					if (this.permsService.perms?.administrative) {
						const assoc_sub_user_ids = this.store.getFusSpreadAssocIds(
							this.followupserie
						)
						assocUserId = assoc_sub_user_ids[0]
					}

					const location_id = this.followupserie.location_id
					const fusStartMom = moment.utc(
						this.followupserie.followupserie_date +
							" " +
							this.followupserie.followupserie_time
					)
					const fusEndMom = moment.utc(
						this.followupserie.followupserie_date_to +
							" " +
							this.followupserie.followupserie_time_to
					)
					const day = fusStartMom.day()
					//find ta with a DIFFERENT user_id, within the same fus times, same day
					const tas = this.store
						.getSiteDataTable("time_allocations")
						.filter(
							(ta) =>
								ta.user_id != assocUserId &&
								ta.day == day &&
								location_id == ta.location_id
						)
					if (tas.length) {
						for (let ta of tas) {
							const taStartMom = moment.utc(
								fusStartMom.format(ConfigDefinitions.momentDateFormat) +
									" " +
									ta.time
							)
							const taEndMom = moment.utc(
								fusStartMom.format(ConfigDefinitions.momentDateFormat) +
									" " +
									ta.time_to
							)
							if (
								fusStartMom.isBetween(taStartMom, taEndMom, null, "[]") ||
								fusEndMom.isBetween(taStartMom, taEndMom, null, "[]") ||
								taStartMom.isBetween(fusStartMom, fusEndMom, null, "[]") ||
								taEndMom.isBetween(fusStartMom, fusEndMom, null, "[]")
							) {
								this.locationWarning = this.lang.getVal(
									"time_allocation_warning"
								)
							}
						}
					}
				}
				const cc = this.store.cc()
				if (
					this.permsService.perms?.administrative &&
					this.followupserie.is_assoc == "yes" &&
					cc?.time_room_allocation == "yes"
				) {
					const assoc_sub_user_ids = this.store.getFusSpreadAssocIds(
						this.followupserie
					)
					const assocUserId = assoc_sub_user_ids[0]

					const fusStartMom = moment.utc(
						this.followupserie.followupserie_date +
							" " +
							this.followupserie.followupserie_time
					)
					const fusEndMom = moment.utc(
						this.followupserie.followupserie_date_to +
							" " +
							this.followupserie.followupserie_time_to
					)

					const userTAs = this.store
						.getSiteDataTable("time_allocations")
						.filter((ta) => ta.user_id == assocUserId)
					if (userTAs?.length) {
						const tas = this.store
							.getSiteDataTable("time_allocations")
							.filter(
								(ta) => ta.user_id == assocUserId && fusStartMom.day() == ta.day
							)
						const foundTas = tas.find((ta) => {
							const taStartMom = moment.utc(
								fusStartMom.format(ConfigDefinitions.momentDateFormat) +
									" " +
									ta.time
							)
							const taEndMom = moment.utc(
								fusStartMom.format(ConfigDefinitions.momentDateFormat) +
									" " +
									ta.time_to
							)

							return (
								fusStartMom.isBetween(taStartMom, taEndMom, null, "[]") &&
								fusEndMom.isBetween(taStartMom, taEndMom, null, "[]")
							)
						})
						if (!foundTas) {
							this.locationWarning = this.lang.getVal("not_in_allocation")
						}
					}
				}

				if (
					cc?.time_room_allocation == "yes" &&
					!this.permsService.perms?.administrative
				) {
					//if this user does NOT have a time_allocation for this room and time - THEY CANNOT CREATE THIS MEETING!!!

					const fusStartMom = moment.utc(
						this.followupserie.followupserie_date +
							" " +
							this.followupserie.followupserie_time
					)
					const fusEndMom = moment.utc(
						this.followupserie.followupserie_date_to +
							" " +
							this.followupserie.followupserie_time_to
					)

					const tas = this.store
						.getSiteDataTable("time_allocations")
						.filter(
							(ta) =>
								ta.user_id == cc.user_id &&
								ta.location_id != 0 &&
								ta.location_id == this.followupserie.location_id &&
								fusStartMom.day() == ta.day
						)
					const foundTas = tas.find((ta) => {
						const taStartMom = moment.utc(
							fusStartMom.format(ConfigDefinitions.momentDateFormat) +
								" " +
								ta.time
						)
						const taEndMom = moment.utc(
							fusStartMom.format(ConfigDefinitions.momentDateFormat) +
								" " +
								ta.time_to
						)

						return (
							fusStartMom.isBetween(taStartMom, taEndMom, null, "[]") &&
							fusEndMom.isBetween(taStartMom, taEndMom, null, "[]")
						)
					})
					if (!foundTas) {
						this.errors.location_id = this.lang.getVal("unpermitted")
						//create error / valication for location_id - "unpermitted"
					}
				}
			}
		}

		if (
			this.errors.followupserie_du_remarks &&
			this.errors.followupserie_du_remarks !=
				this.lang.getVal("has_closing_tags")
		) {
			this.errors.followupserie_du_remarks = this.lang.getVal(
				"meeting_was_deleted"
			)
		}

		if (
			this.permsService.owner_has_users &&
			!this.permsService.perms?.add_new_patient &&
			this.errors.patient_id
		) {
			this.errors.patient_id = this.lang.getVal("select_a_patient")
		}

		this.isFormSubmittableWithOrig = !this.isFollowupserieLikeOrig()
		this.isFormSubmittable = this.validator.formIsValid(this.errors)
		if (this.isInVac && this.followupserieOrig?.meeting_on_holiday == "no") {
			this.isFormSubmittableWithOrig = true
		}

		// this.isFormSubmittable = this.validator.validateEntireFormGen(this.newRow, this.collectionFields,this.objectCollection);
	}

	backFromChangeDetails(obj: any = null) {
		if (obj) {
			this.followupserie.followupserie_series_id = obj.followupserie_series_id
			this.followupserie.change_series = obj.change_series
			this.followupserie.followupserie_until_date = obj.until_date
			this.followupserie.followupserie_du_message = obj.message
			this.followupserie.followupserie_du_remarks = obj.remarks
			this.followupserie.current_original_date = (this.followupserie as any)
				?.start_unix
			this.followupserie.mode = obj.mode
			if (["update", "duplicate"].includes(obj.mode)) {
				this.save(true)
			} else if (obj.mode == "delete") {
				this.delete(true)
			}
		}
	}

	async preUpdate(mode: FusUpdateModes) {
		await this.store.timeout(10)
		this.update(mode)
	}

	async update(mode: FusUpdateModes) {
		this.followupserie.mode = mode

		//when do these happen?
		if (["update", "duplicate"].includes(mode)) {
			this.save(true)
		} else if (mode == "delete") {
			this.delete(true)
		}
	}
	async preSave() {
		await this.store.timeout(10)
		this.save(true)
	}

	prepFusForServer() {
		if (this.followupserie.meeting_with != "meeting") {
			this.followupserie.meeting_title = ""
		}
		if (this.followupserie.followuptype_id == 5) {
			this.followupserie.location_id = 0
		}
		if (this.followupserie.followuptype_id != 5) {
			this.followupserie.followupserie_date_to =
				this.followupserie.followupserie_date
			if (this.followupserie.followupserie_time) {
				let arr = this.followupserie.followupserie_time.split(":")
				let hour = Number(arr[0])
				let minute = Number(arr[1])
				minute += Number(this.followupserie.length)
				let hours = minute / 60
				for (let i = 1; i <= hours; i++) {
					if (minute >= 60) {
						hour++
						minute = minute - 60
					}
				}

				this.followupserie.followupserie_time_to = `${hour < 10 ? "0" + hour : hour}:${minute < 10 ? "0" + minute : minute}:00`
			}
		}
		if (this.store.isFusAReminder(this.followupserie)) {
			this.followupserie.repeat_days = 1
			this.followupserie.takes_place = "no"
		}
		if (this.isInVac) {
			this.followupserie.meeting_on_holiday = "yes"
			this.followupserie.change_series = "only_one"
		}
	}

	async handleDuplicateApprove() {
		this.isSaving = "save"

		this.prepFusForServer()

		const res: any = await this.apiService.post(
			"prepare_for_save",
			this.followupserie
		)
		this.isSaving = false
		if (!res) {
			return
		}

		if (res.message == "overlap") {
			this.modalProps = {
				name: "confirm-overlap",
				message: res.message_details,
			}
		} else {
			if (this.followupserie.patient_id) {
				this.store.detectMixedListChangeNeeded(
					"followups",
					this.followupserie.patient_id
				)
			}
			if (this.meeting_request?.id) {
				const patient_id = this.followupserie.patient_id
					? this.followupserie.patient_id
					: 0
				this.isSaving = "save"
				await this.store.deactivate_meeting_request(
					this.meeting_request.id,
					res?.add?.date,
					res?.add?.time,
					patient_id,
					true
				)
				this.isSaving = false
			}
			this.onClose.emit(res)
			this.store.modalCloseRequestSubject.next("task")
			// if (res.followupserie) {
			//   //if(is_group=='yes'){
			//   // open modal(update_group)
			// //}
			// }
		}
	}

	async save(response: boolean = false) {
		if (!response) {
			return
		}
		if (this.isSaving) {
			return
		}

		await this.validateEntireForm()
		if (!this.isFormSubmittable) {
			return
		}

		if (
			!this.isUpdateMode &&
			this.followupserie.is_new_patient_or_contact == "yes"
		) {
			const collectionName =
				this.followupserie.meeting_with == "contact" ? "contacts" : "patients"
			const item = this.store
				.getSiteDataTable(collectionName)
				.find((it) => it.name == this.followupserie.name)
			if (item) {
				this.modalProps = { name: "confirm-duplicate", objectName: item.name }
				return
			}
		}
		this.handleDuplicateApprove()
	}

	async handleDeleteConfirm(response: any) {
		this.modalProps = null

		if (response) {
			if (this.isSaving) {
				return
			}
			this.isSaving = "delete"
			const res: any = await this.apiService.post(
				"delete_followupserie",
				this.followupserie
			)
			this.isSaving = false
			if (res.success) {
				if (this.followupserie.patient_id) {
					this.store.detectMixedListChangeNeeded(
						"followups",
						this.followupserie.patient_id
					)
				}
				this.onClose.emit(res)
				// if (res.followupserie) {
				// 	this.onClose.emit({...res.followupserie,deleted:true});
				// }else{
				// 	this.onClose.emit();
				// }
			}
		}
	}

	async delete(response: boolean = false) {
		//if date <=today and date >=3days ago
		const fusMom = moment.utc((this.followupserie as any).date)
		const today = moment.utc().startOf("day")
		if (fusMom.isSameOrBefore(today) && !this.isPastEvent) {
			this.isSaving = "delete"
			const res = await this.apiService.post("has_followups_with_text", {
				series_id: this.followupserie.id,
			})
			this.isSaving = false
			if (res?.num) {
				this.modalProps = { name: "confirm-delete", response }
				return
			}
		}
		this.handleDeleteConfirm(response)
	}

	keyUpMeetingType(obj: AutoCompleteKeyUpObj) {
		if (this.isUpdateMode) {
			return
		}
		if (!obj.isIdenticalToPreviousValue) {
			this.meetingType = null
			this.followupserie.meetingtype_id = null
			return this.validateEntireForm()
		}
	}
	keyUpLocation(obj: AutoCompleteKeyUpObj) {
		if (this.isUpdateMode) {
			return
		}
		if (!obj.isIdenticalToPreviousValue) {
			this.followupserie.location_id = null
			return this.validateEntireForm()
		}
	}
	keyUpTarif(obj: AutoCompleteKeyUpObj) {
		if (this.isUpdateMode) {
			return
		}
		if (!obj.isIdenticalToPreviousValue) {
			this.followupserie.tarif_id = null
			return this.validateEntireForm()
		}
	}
	handleChangeSeriesChange() {
		this.reCalcLocationApprovedIds()
		this.validateEntireForm()
		setTimeout(() => {
			this.untilDatePicker?.focus()
		}, 50)
	}
	async reCalcLocationApprovedIds() {
		this.locationApprovedIds = this.getInitLocations().map((it) => it.id)

		if (this.locationTagsObj.hasAny) {
			this.locationApprovedIds = this.locationApprovedIds.filter((id) =>
				this.locationTagsObj.ids.includes(id)
			)
		}

		if (!this.ownerHasUsers) {
			return
		}
		if (this.followupserie.followuptype_id != 1) {
			return
		}

		this.prepFusForServer()

		//go over locations and update the available locations
		const approvedIds: any[] = []

		const locationIds = [...this.locationApprovedIds]
		for (let locId of locationIds) {
			const testFus = this.preOverlapChange({ ...this.followupserie })
			testFus.location_id = locId
			const overlapFus = await this.overlapService.find_overlap(testFus)

			if (!overlapFus) {
				approvedIds.push(locId)
			}
		}
		this.locationApprovedIds = approvedIds
	}

	async chooseLocation(obj: any) {
		if (!obj || !obj.id) {
			this.followupserie.location_id = 0
			return this.validateEntireForm()
		}
		this.otObjs.locationObj = obj
		this.followupserie.location_id = obj.id
		this.validateEntireForm()
		await this.store.timeout(50)
		if (
			this.tarifFuzzyInput &&
			this.permsService?.owner_has_users &&
			["patient", "user"].includes(this.followupserie.meeting_with)
		) {
			this.tarifFuzzyInput.focus()
		}
	}
	async chooseTarif(obj: any) {
		if (!obj || !obj.id) {
			this.followupserie.tarif_id = 0
			return this.validateEntireForm()
		}
		this.otObjs.tarifObj = obj
		this.followupserie.tarif_id = obj.id
		this.validateEntireForm()
		await this.store.timeout(50)
		if (this.permsService?.owner_has_users) {
			this.timePicker?.inpEl?.nativeElement.focus()
		}
	}

	chooseMeetingtype(obj: any, avoidValidate: boolean = false) {
		// if (this.isUpdateMode) { return; }
		this.meetingType = obj

		this.emptyAssoc()

		if (!obj || !obj.id) {
			this.followupserie.meetingtype_id = 0
			this.updateIsFusInVac()
			return this.validateEntireForm()
		}
		this.otObjs.meetingObj = obj
		this.followupserie.meetingtype_id = obj.id
		this.followupserie.length = obj.length
		this.followupserie.price = obj.price

		this.tryGetLastPrice()
		this.updateIsFusInVac()
		if (!avoidValidate) {
			this.validateEntireForm()
		}
	}

	keyUpPatientOrContact(obj: AutoCompleteKeyUpObj) {
		if (!obj.isIdenticalToPreviousValue) {
			this.patient = null
			this.followupserie.patient_id = null
			this.followupserie.contact_id = null
			this.followupserie.user_id = null
			this.followupserie.is_assoc = "yes"
			return this.validateEntireForm()
		}
	}

	emptyAssoc() {
		if (!this.only_therapist_id) {
			this.sub_users = []
			this.followupserie.assoc_sub_user_ids = []
		}
	}

	async choosePatientOrContact(obj: any, avoidValidate: boolean = false) {
		this.emptyAssoc()
		this.patient = null
		this.followupserie.is_assoc = "yes"
		if (!obj.id) {
			this.followupserie.patient_id = 0
			this.followupserie.contact_id = 0
			this.followupserie.user_id = 0
			return this.validateEntireForm()
		}

		this.followupserie.patient_id = 0
		this.followupserie.contact_id = 0
		this.followupserie.user_id = 0
		this.otObjs.personObj = obj
		switch (obj.typeClassName) {
			case "patients":
				this.followupserie.patient_id = obj.id
				this.followupserie.meeting_with = "patient"
				break
			case "contacts":
				this.followupserie.contact_id = obj.id
				this.followupserie.meeting_with = "contact"
				break
			case "sub_users":
				this.followupserie.user_id = obj.id
				this.followupserie.meeting_with = "user"
				break
		}
		let isPatientOrUSer = obj.typeClassName != "contacts"

		// this.followupserie.meeting_with = (isPatient ? 'patient' : 'contact');
		// this.followupserie[(isPatient ? 'patient_id' : 'contact_id')] = obj.id;
		// this.followupserie[(!isPatient ? 'patient_id' : 'contact_id')] = 0;
		if (!avoidValidate) {
			this.setMeetingInfo(!isPatientOrUSer)
			this.validateEntireForm()
		}
		this.tryGetPatient()
		await this.store.timeout(50)
		if (
			this.permsService?.owner_has_users &&
			this.subUsersFuzzyInput &&
			!this.only_therapist_id
		) {
			this.subUsersFuzzyInput.focus()
		} else {
			this.timePicker?.inpEl?.nativeElement.focus()
		}
	}

	updRepeatOptions() {
		let repeatOptions = ["one_time"]
		if (this.isPastAddition || this.isInVac) {
			this.repeatOptions.set(repeatOptions)
			return
		}
		if (this.isUpdateMode && this.followupserie.series_repeat != "one_time") {
			repeatOptions = []
		}
		switch (this.followupserie.followuptype_id) {
			case 4:
				repeatOptions.push("series_daily")
			case 1:
			case 6:
				repeatOptions = [
					...repeatOptions,
					"series_weekly",
					"series_monthly",
					"series_2weekly",
					"series_3weekly",
				]
				break
		}
		this.repeatOptions.set(repeatOptions)
	}

	updFollowuptype(avoidValidate: boolean = false) {
		this.updRepeatOptions()
		if (this.isUpdateMode) {
			return
		}

		this.followupType = this.store
			.getSiteDataTable("followuptypes")
			.find((it) => it.id == this.followupserie.followuptype_id)

		this.followupserie.price = this.followupType?.price
		this.followupserie.length = this.followupType?.length
		this.followupserie.takes_place = this.followupType?.takes_place

		switch (this.followupserie.followuptype_id) {
			case 4:
				this.followupserie.meetingtype_id = 0
				break
			case 5: //vacation
				this.updFollowupserie("meeting_with", "meeting")
				break
			case 6:
				this.followupserie.meetingtype_id = 0
				break
		}
		if (!this.repeatOptions().includes(this.followupserie.series_repeat)) {
			this.followupserie.series_repeat = "one_time"
		}
		if (!avoidValidate) {
			this.validateEntireForm()
			if (this.followupserie.followuptype_id == 1) {
				this.setMeetingInfo(false)
			}
		}
		if (this.followupserie.followuptype_id == 5) {
			this.followupserie.name = ""
			this.followupserie.new_phone_input = ""
			this.followupserie.new_phone_input2 = ""
			this.followupserie.payor_id = 0
			this.followupserie.followupserie_time_to =
				this.followupserie.followupserie_time
			if (this.followupserie.followuptype_id == 5) {
				this.followupserie.followupserie_time_to = moment
					.utc(
						this.followupserie.followupserie_date +
							" " +
							this.followupserie.followupserie_time
					)
					.add(1, "hour")
					.format("HH:mm")
			}
			//this.followupserie.followupserie_time_to = '';
			this.validateEntireForm()
			this.datePicker.focus()
		}
		this.updateIsFusInVac()
	}

	openAddMeetingtypeModal() {
		this.modalProps = {
			name: "add-meetingtype",
			fuzzyName: this.meetingtypeFuzzyInput.returnSearchStrForAdding(),
		}
	}
	handleAddMeetingtypeClose(obj: any) {
		this.followupserie.meetingtype_id = obj.id
		this.meetingtypeFuzzyInput.searchStr = obj.name
		this.chooseMeetingtype(obj)
	}
	handleAddLocationClose(obj: any) {
		this.followupserie.location_id = obj.id
		this.locationFuzzyInput.searchStr = obj.name
		this.chooseLocation(obj)
	}
	openAddLocationModal() {
		this.modalProps = {
			name: "add-location",
			fuzzyName: this.locationFuzzyInput.returnSearchStrForAdding(),
		}
	}
	openAddTarifModal() {
		this.modalProps = {
			name: "add-tarif",
			fuzzyName: this.tarifFuzzyInput.returnSearchStrForAdding(),
		}
	}
	handleAddTarifClose(obj: any = null) {
		if (obj) {
			this.followupserie.tarif_id = obj.id
			this.tarifFuzzyInput.searchStr = obj.name
		}
		this.validateEntireForm()
	}

	// delete(doDelete: boolean = false) {
	//   if (doDelete) {
	//api for delete....
	//  }
	// }

	async addInvoice(arg: any) {
		let description = this.otObjs.personObj.name
		if (this.followupserie.meeting_with == "patient") {
			description = this.store.getAddInvoiceDescriptionDefault(
				description,
				this.followupserie.patient_id
			)
		}
		this.modalProps = {
			name: "add-invoice",
			description,
		}
	}
	addPatient() {
		this.updFollowupserie(
			"is_new_patient_or_contact",
			flipYesNo(this.followupserie.is_new_patient_or_contact)
		)
		this.onNewPerson()
		this.validateEntireForm()
	}
	handleChangeLimitDateClose(doClose: boolean = false) {
		doClose && this.onClose.emit()
	}
	asu(obj: any) {}
	async updateSubUsers(objs: any[]) {
		this.sub_users = objs.map((obj) => {
			const isGroup = obj.typeClassName != "sub_users"
			if (isGroup && !String(obj.id).startsWith("g")) {
				obj.id = "g" + obj.id
			}
			return obj
		})
		this.followupserie.assoc_sub_user_ids = this.sub_users.map((row) =>
			String(row.id)
		)

		await this.updateIsFusInVac()
		await this.suggestLocation()

		if (!this.followupserie.location_id) {
			const location_id = objs.find(
				(obj) => obj.typeClassName === "sub_users"
			)?.location_id
			if (location_id) {
				const location = this.store.searchSiteDataItem(location_id, [
					"locations",
				])
				if (location) {
					this.locationFuzzyInput.searchStr = location.name
					this.chooseLocation(location)
				}
			}
			//find first non group user and its location_id and "choose" it
		}
		this.suggestTarif()
		this.validateEntireForm()
	}

	addSubUser(subUserObj: any) {
		if (subUserObj?.id) {
			// if(this.subUsersFuzzyInput){
			//   this.subUsersFuzzyInput.clear();
			// }
			const obj = { ...subUserObj }
			const isGroup = obj.typeClassName != "sub_users"
			obj.id = (isGroup ? "g" : "") + obj.id

			if (this.followupserie.assoc_sub_user_ids.includes(obj.id)) {
				return
			}

			this.sub_users = [...this.sub_users, obj]
			this.followupserie.assoc_sub_user_ids = this.sub_users.map((row) =>
				String(row.id)
			)

			this.updateIsFusInVac()
			this.suggestLocation()
		}
		this.validateEntireForm()
	}

	deleteSubUser(subUserObj: any) {
		this.sub_users = this.sub_users.filter((it) => it.id != subUserObj.id)
		this.followupserie.assoc_sub_user_ids = this.sub_users.map((row) =>
			String(row.id)
		)
		this.updateIsFusInVac()
		this.validateEntireForm()
	}

	async openPatientForm() {
		const isNew = this.followupserie.is_new_patient_or_contact == "yes"
		const inputObj = isNew
			? {
					name: this.followupserie.name,
					phone: this.followupserie.new_phone_input,
					email: this.followupserie.new_phone_input2,
					notifiy: this.followupserie.notifiy,
					payor_id: this.followupserie.payor_id,
				}
			: {
					name: this.personFuzzyInput?.searchStr || "",
				}

		this.modalProps = {
			name: "insert-patient-form",
			inputObj,
		}
	}
	handleInsertPatientClose(newPatient: any) {
		if (!newPatient) {
			return
		}
		this.followupserie.is_new_patient_or_contact = "no"
		this.choosePatientOrContact(newPatient)
		if (newPatient?.assoc) {
			// this.emptyAssoc();
			const objs = this.store
				.getSiteDataTable("sub_users")
				.filter((it) => newPatient.assoc.includes(it.id))
			// objs.forEach(it=>this.addSubUser({...it,typeClassName:"sub_users"}));
		}
	}

	changeIsAssoc() {
		if (this.followupserie.is_assoc == "no") {
			this.emptyAssoc()
		}
		this.validateEntireForm()
	}

	openSwitchLocation() {
		this.switchLocationOpen = !this.switchLocationOpen

		const thisFus: any = this.followupserie

		if (this.switchLocationOpen) {
			this.switchLocationRows = this.dayEventsAll
				.filter((ev) => {
					return (
						thisFus.time == ev.time &&
						thisFus.time_to == ev.time_to &&
						thisFus.id != ev.id &&
						thisFus.date == ev.date
					)
				})
				.map((ev) => {
					const location = this.store.searchSiteDataItem(ev.location_id, [
						"locations",
					])
					const assocUsers = ev?.assoc_sub_user_ids?.length
						? this.store
								.getAssocSubUsersForFus(ev)
								.map((it: any) => it.name)
								.join(", ")
						: ""

					return {
						id: ev.id,
						location_id: ev.location_id,
						location,
						assocUsers,
					}
				})
		}
	}

	async flipLocation(locationRow: any) {
		const sendObj: any = {
			date: (this.followupserie as any).date,
			fus_id1: this.followupserie.id,
			fus_id2: locationRow.id,
		}
		this.switchLocationSpinner = true
		const res = await this.apiService.post("flip_location", sendObj)
		this.switchLocationSpinner = false
		if (res.message == "overlap") {
			this.modalProps = {
				name: "confirm-overlap",
				message: res.message_details,
			}
		} else {
			if (this.followupserie.patient_id) {
				this.store.detectMixedListChangeNeeded(
					"followups",
					this.followupserie.patient_id
				)
			}
			this.onClose.emit(res)
		}
	}
	handleNotifiyChange() {
		this.followupserie.notifiy = flipYesNo(this.followupserie.notifiy)
	}

	chooseTagsForLocations(tagObjs: any[]) {
		this.locationTagsObj.ids = []
		this.store.fillObjForTags(tagObjs, this.locationTagsObj, "location")
		this.reCalcLocationApprovedIds()
	}
	chooseTagsForUsers(tagObjs: any[]) {
		this.userExcludeIds = this.store
			.getSiteDataTable("sub_users")
			.filter((it) => it.active == "no")
			.map((it) => it.id)
		this.userTagsObj.ids = []
		this.store.fillObjForTags(tagObjs, this.userTagsObj, "user")
		if (this.userTagsObj.hasAny) {
			this.userExcludeIds = this.store
				.getSiteDataTable("sub_users")
				.filter((it) => {
					if (it.active == "no") {
						return true
					}
					if (!this.userTagsObj.ids.includes(it.id)) {
						return true
					}
					return false
				})
				.map((it) => it.id)
		}
	}

	async deactivateMR() {
		this.deactivateSpin = true
		await this.store.deactivate_meeting_request(this.meeting_request.id)
		this.deactivateSpin = false
		this.onClose.emit({})
	}
	openFilterSubUsers() {
		this.filterSubUsersOpen = !this.filterSubUsersOpen
		setTimeout(() => this.subUsersAC?.focus(), 50)
	}
	openFilterLocations() {
		this.filterLocationsOpen = !this.filterLocationsOpen
		setTimeout(() => this.locationsAC?.focus(), 50)
	}
}
